import { render, staticRenderFns } from "./ListTruewallet.vue?vue&type=template&id=1000f8dd"
import script from "./ListTruewallet.vue?vue&type=script&lang=js"
export * from "./ListTruewallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports